import React from 'react';

// Import images properly
import CorporateImg from '../../assets/vacation/2e67dead795a4c4a000097410406d523fcd15127.jpg';
import WildlifeImg from '../../assets/vacation/5a4e88cdfce9b6cc37b76d063c0ff5c876e90b85.jpg';
import WeekendImg from '../../assets/vacation/00177c5c5d4b1638b090742d8cb49c2fc6db333b.jpg';
import PilgrimageImg from '../../assets/vacation/78829b5e2d3844ea2c2fb9c75e419fa54bea9f3a.jpg';
import HoneymoonImg from '../../assets/vacation/707178e4063403660f4ea24e02bfd9dc3d2f13a8.jpg';
import FamilyImg from '../../assets/vacation/a436af4477bb347761b87fff03b62b3547665002.jpg';
import BeachImg from '../../assets/vacation/b8acd621c114c38644b9398093be6dc66f315551.jpg';
import AdventureImg from '../../assets/vacation/b31754cec37ced818a399ab2187560b2ba295f19.jpg';
import NatureImg from '../../assets/vacation/f6344645a465da09fd1071857541c1abfdc663d7.jpg';
import MainImg from '../../assets/PerfectVacation.png';
import BookNowButton from '../common/Button';
const categories = [
  { name: 'Wildlife', image: WildlifeImg },
  { name: 'Family Tour', image: FamilyImg },
  { name: 'Honeymoon', image: HoneymoonImg },
  { name: 'Adventure', image: AdventureImg },
  { name: 'Weekend Gateway', image: WeekendImg },
  { name: 'Beach', image: BeachImg },
  { name: 'Pilgrimage', image: PilgrimageImg },
  { name: 'Nature', image: NatureImg },
  { name: 'Corporate', image: CorporateImg },
];

function PerfectVacation() {
  return (
    <div className='grid w-full grid-cols-1 gap-6 bg-[#f0f9f8] md:grid-cols-3'>
      {/* Main Image with Overlay */}
      <div className='group relative shadow sm:w-[112%] md:row-span-2'>
        <img
          src={MainImg}
          alt='Perfect Vacation'
          className='h-full w-full object-cover'
        />

        {/* Center Text */}
        <div className='absolute inset-0 mt-12 flex flex-col items-center justify-center text-start'>
          <h2 className='text-2xl font-medium leading-snug text-white drop-shadow-lg md:text-[40px]'>
            Special Discount <br /> On Last Minute Booking
          </h2>
        </div>

        {/* Bottom Right Button */}
        <div className='absolute bottom-4 right-4 md:bottom-[100px] md:right-[80px]'>
          <BookNowButton />
        </div>
      </div>

      {/* Right Section */}
      <div className='md:col-span-2'>
        {/* Heading */}
        {/* <h2 className='mb-6 text-center text-2xl font-semibold text-[#495BFF] md:mt-6 md:text-start md:text-4xl'>
          Plan Your Perfect Vacation With Us
        </h2> */}
        <p className='mb-6 text-center text-2xl font-medium leading-tight tracking-normal text-[#495BFF] sm:ml-[6%] md:mt-6 md:text-start md:text-[40px]'>
          Plan Your Theme Vacation With Us
        </p>
        {/* Grid Categories */}
        <div className='mb-8 grid grid-cols-2 gap-6 px-4 md:mb-4 md:grid-cols-3 lg:px-16'>
          {categories.map((item, index) => (
            <div
              key={index}
              className={`group relative overflow-hidden rounded-lg shadow transition hover:shadow-lg ${index === categories.length - 1 ? 'col-span-2 md:col-span-1' : ''}`} // Full width on mobile for last image
            >
              <img
                src={item.image}
                alt={item.name}
                className='h-40 w-full object-cover transition-transform duration-500 group-hover:scale-105 md:h-48'
              />
              <div className='absolute inset-0 bg-black/30 transition group-hover:bg-black/40' />
              <p className='absolute bottom-2 left-2 text-lg font-semibold text-white'>
                {item.name}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default PerfectVacation;
